module.exports = "/_next/static/images/triplebyte-edit-organization-3373bb12eb16c998e3cd02a992d6fd06.jpg";